var _rect, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResolutionAlaramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.6686 6.86451L15.0501 7.48622C15.372 8.13025 15.5665 8.83041 15.6228 9.54821H13.9663V10.3815H15.6256C15.4312 13.1567 13.2431 15.376 10.4709 15.6096V13.9572H9.63724V15.6147C6.83595 15.4293 4.59742 13.212 4.38539 10.4126H5.96283V9.57931H4.38505C4.59325 6.78909 6.81531 4.57317 9.60609 4.3727V5.9541H10.4391V4.37455C11.5838 4.46103 12.6745 4.89656 13.564 5.62238L14.1535 5.02966C11.4079 2.73633 7.323 3.103 5.02966 5.84864C2.73633 8.59428 3.103 12.6792 5.84864 14.9725C8.59428 17.2659 12.6792 16.8992 14.9725 14.1535C16.6872 12.1006 16.9637 9.20485 15.6685 6.86452L15.6686 6.86451ZM14.1216 6.14986L14.7091 5.55927L15.8811 4.38111L16.4714 4.96851L15.2427 6.20389L14.6496 6.80019L10.0351 11.4398L7.39222 8.74164L7.98757 8.1586L10.0394 10.2535L14.1216 6.14986Z",
    fill: "#6F7171"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResolutionAlaramIcon);
export default __webpack_public_path__ + "static/media/resolution-alaram-icon.2cf9d122f786fe20f9d2b5edd90d8396.svg";
export { ForwardRef as ReactComponent };